import React, { Suspense } from "react";

import "animate.css";
import "../assets/css/style.css";
import "./Testimonial.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import BigCircal from "../assets/images/testimonial/big-circle.png";
import User from "../assets/images/testimonial/masala-client.png";
import Google from "../assets/images/testimonial/Google_logo.webp";
import SmallCircal from "../assets/images/testimonial/smallcircle.png";
import { FaQuoteRight, FaQuoteLeft } from "react-icons/fa";
import { IoStar } from "react-icons/io5";

const Testimonial = () => {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  };
  return (
    <>
      <section className="testimonial-section mt-md-5 mt-4 testimonial-phn-bottom-response">
        <div className="container-md container-fluid px-0 px-3 py-4">
          <div className="row">
            <div className="col-xl-6 offset-xl-1 col-lg-7 order-last order-lg-first position-relative">
              <div className="big-circle-img position-absolute">
                <FaQuoteRight className="right-quote" />
              </div>
              <div className="small-circle-img position-absolute">
                <FaQuoteLeft className="left-quote" />
              </div>
              <div className="testimonial-slider">
                <Suspense fallback={<div>Loading...</div>}>
                  <Slider {...settings} className="testimonial-slider-dots">
                    <div className="review_box">
                      <div className="customer_box">
                        <div className="review_box__img">
                          <img
                            src={User}
                            className="img-fluid"
                            loading="lazy"
                            alt="user"
                          />
                        </div>
                        <div className="customer-name">
                          <h6>Zawad Zahid</h6>
                          <p>15 days ago on Google</p>
                        </div>
                      </div>
                      <div className="review_box__rating">⭐⭐⭐⭐⭐</div>
                      <div className="customer_review">
                        <p>
                          10/10 food. My favorite was the potato/eggplant curry,
                          butter chicken, and chicken biriyani. The tandoori
                          chicken was fresh and tender. The naan was so fluffy!!
                          Even their fish was really good and I don't even like
                          fish.
                        </p>
                      </div>
                    </div>
                    <div className="review_box">
                      <div className="customer_box">
                        <div className="review_box__img">
                          <img
                            src={User}
                            className="img-fluid"
                            loading="lazy"
                            alt="user"
                          />
                        </div>
                        <div className="customer-name">
                          <h6>Amir Williams</h6>
                          <p>20 days ago on Google</p>
                        </div>
                      </div>
                      <div className="review_box__rating">⭐⭐⭐⭐⭐</div>
                      <div className="customer_review">
                        <p>
                          Food is really delicious. They restarted their Buffet
                          which is a great option. Many delicious main dishes,
                          desserts, salads and fresh Naan served on your table.
                          Love it. And the owner Sahil is so amazing in making
                          all his guests feel welcomed. Must visit.
                        </p>
                      </div>
                    </div>
                    <div className="review_box">
                      <div className="customer_box">
                        <div className="review_box__img">
                          <img
                            src={User}
                            className="img-fluid"
                            loading="lazy"
                            alt="user"
                          />
                        </div>
                        <div className="customer-name">
                          <h6>Bryan Richardson</h6>
                          <p>27 days ago on Google</p>
                        </div>
                      </div>
                      <div className="review_box__rating">⭐⭐⭐⭐⭐</div>
                      <div className="customer_review">
                        <p>
                          My family and I have been having Thanks giving dinner
                          at masala for 12 years now… And every year the food
                          tastes better than the last year! Highly recommend
                          this restaurant if you’re looking for an easy-going
                          Indian restaurant with really delicious flavors!
                        </p>
                      </div>
                    </div>
                    {/* <div>
                      <p className="masala-common-content mb-0 pb-0">
                        Fantastic Indian food! Every dish is distinctive in
                        taste from other dishes and the quality of ingredients
                        is notable. Our family are loyal and order from Masala
                        of India Cuisine for most birthdays and special
                        occasions - even after moving out of the neighborhood.
                        My favorites are the saag paneer, veggie korma, and
                        vegetarian mixed appetizer. The meat-eaters in the
                        family love the chicken jalfrezie, chicken masala and
                        the Goa curry . The vindaloo is very tasty, too!
                      </p>
                      <p className="masala-common-content text-center">
                        <div className="start-color">
                          <IoStar />
                          <IoStar />
                          <IoStar />
                          <IoStar />
                          <IoStar />
                        </div>
                        <strong>62rubies</strong>
                      </p>
                    </div>
                    <div>
                      <p className="masala-common-content mb-0 pb-0">
                        I've been here pre-pandemic when they still had the
                        buffet, and post pandemic after they quit the buffet.
                        That almost caused me to skip dining here. Now I see
                        they are finally going to re-open the buffet. About
                        time! This is the best Indian restaurant North of
                        Seattle and to finally see they are re-starting their
                        buffet will save their asses.
                      </p>
                      <p className="masala-common-content text-center">
                        <div className="start-color">
                          <IoStar />
                          <IoStar />
                          <IoStar />
                          <IoStar />
                          <IoStar />
                        </div>
                        <strong>Kurt</strong>
                      </p>
                    </div>
                    <div>
                      <p className="masala-common-content mb-0 pb-0">
                        This is a restaurant feels like you are eating in India.
                        Taste and the flavors are great and we love here as a
                        whole family.
                      </p>
                      <p className="masala-common-content text-center">
                        <div className="start-color">
                          <IoStar />
                          <IoStar />
                          <IoStar />
                          <IoStar />
                          <IoStar />
                        </div>
                        <strong>Hilal Cil</strong>
                      </p>
                    </div> */}
                  </Slider>
                </Suspense>
              </div>
            </div>
            <div className="col-xl-4 mb-5 mb-xl-0 offset-xl-1 col-lg-5 align-self-center">
              <div className="section-header testimonial-right">
                <h2>Testimonials</h2>
                <h3>What our clients say</h3>
                <div className="review_heading__left">
                  <div className="google_img">
                    <img
                      src={Google}
                      className="img-fluid"
                      loading="lazy"
                      alt="logo"
                    />
                  </div>
                  <div className="review_content">
                    <h6>1,231 customer reviews</h6>
                    <div>
                      <b>4.3</b>
                      <p className="rating_star">⭐⭐⭐⭐⭐</p>
                    </div>
                  </div>
                </div>
                <button type="submit" className="review-btn">
                  <a
                    className="text-white"
                    href="https://g.page/r/CVh39uEqKlO9EAE/review"
                    target="blank">
                    {" "}
                    Leave a Review{" "}
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
